<template>
  <FaIcon :icon="['fas', 'briefcase']" />
</template>
